import React, { FC, PropsWithChildren } from 'react'

export const DrawerWrapper: FC<PropsWithChildren<{ isOpen: boolean }>> = ({
  isOpen,
  children,
}) => {
  return <>{isOpen ? children : null}</>
}
